import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const React = require("react");
import { isActivePath } from "../../../Shared/utils/browser";
import { Link } from "../../custom_components/components/library/link";
const getMenuIcon = (menuItem)=>{
    if (menuItem == 'Doen') return 'calendar';
    if (menuItem == 'Leren') return 'award';
    if (menuItem == 'Lezen') return 'book';
    if (menuItem == 'Ontmoeten') return 'coffee';
    if (menuItem == 'Word lid') return 'user';
    if (menuItem == 'Vragen') return 'vragen';
    return 'search';
};
const menuLink = (x, handle)=>{
    const isActive = !x.external && isActivePath(x.relative);
    const props = {
        key: x.key,
        className: `menu__link link--iconed ${isActive ? 'menu__link--active' : ''}`,
        url: x.external ? x.absolute : x.relative,
        handle
    };
    return /*#__PURE__*/ _jsxs(Link, {
        ...props,
        children: [
            x.title,
            /*#__PURE__*/ _jsx("svg", {
                className: "link__icon",
                width: "24px",
                height: "24px",
                "aria-hidden": "true",
                children: /*#__PURE__*/ _jsx("use", {
                    xlinkHref: `#icon--menu-${getMenuIcon(x.title)}`
                })
            })
        ]
    });
};
export default menuLink;
